/*
 *
 * InteractiveArea constants
 *
 */

enum ActionTypes {
  ADD_MESSAGE = 'app/InteractiveArea/NEW_MESSAGE',
  FLUSH_MESSAGES = 'app/InteractiveArea/FLUSH_MESSAGES',
  TUTORIAL = 'app/InteractiveArea/TUTORIAL',
}

export default ActionTypes;
